import React from "react";
import './PainPointsSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * PainPointsSection - Sección para mostrar puntos de dolor del cliente
 * "¿Te pasa esto?" - Genera empatía y conexión emocional
 */
const PainPointsSection = ({ title, subtitle, problems = [], highlight, theme = 'dark', backgroundDecoration }) => {
  return (
    <div className={`painPointsContainer painPointsContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      {title && <h2 className="painPointsTitle">{title.toUpperCase()}</h2>}
      {subtitle && <p className="painPointsSubtitle">{subtitle}</p>}

      <div className="problemsList">
        {problems.map((problem, index) => (
          <div className="problemItem" key={index}>
            <span className="problemIcon">❌</span>
            <p className="problemText">{problem}</p>
          </div>
        ))}
      </div>

      {highlight && (
        <>
          <div className="painPointsDivider"></div>
          <p className="highlightText">{highlight}</p>
        </>
      )}
    </div>
  );
};

export default PainPointsSection;
